module.exports = "/assets/data/bf41145079daa4b9d90c60c8ab2daf65-YO62.data.json";